import styled from 'styled-components';

export const Header = styled.div`
  background-image: url(${require('../img/bg.png')});
  background-size: 100% 100%;
`;

export const Container = styled.div`
  height: 32px;
  display: flex;
  line-height: 32px;

  max-width: ${props => (props.is1200 ? '1200px' : '1400px')};
  margin-left: auto;
  margin-right: auto;
`;

export const Location = styled.div`
`;

export const User = styled.div`
  margin-left: auto;
`;

export const Nav = styled.div`
  margin-left: 68px;
`;
